import videoBannerold from "./images/video-banner.jpg";
import payfast from "./images/payfast.jpg";
import videoBanner from "./images/video-banner.png";
export const ImageConstants = {
  videoBannerold,
  payfast,
  videoBanner,
};
